import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as types from 'constants/actionTypes';
import { Checkbox, FormControlLabel } from '@mui/material';

class CheckInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            value: props.value || false,
            error: "",
            name: props.name || ""
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps.value !== this.state.value) {
            if (newProps.name === this.state.name) {
                this.setState({ value: newProps.value });

            }
        }
        else if (!newProps.value)//in case the store does not have any value for this component, just clear it
        {
            if (newProps.name === this.state.name) {
                this.setState({ value: "" });
            }
        }
        if (newProps.error && newProps.error !== this.state.error) {
            this.setState({ error: newProps.error });
        }
    }

    onCheck = (event, value) => {
        this.setState({ value });
        this.props.dispatch({ type: types.FORM_INPUT, value, name: this.props.name });

        if (this.props.onCheck) {
            this.props.onCheck(event);
        }
    }

    render() {
        const p = this.props;
        const e = this.state && this.state.error;
        const showError = e && (this.state.value === undefined || this.state.value == null || this.state.value === false);
        return (
            <div className={`form-group checkbox ${p.className}`} style={{ ...p.containerStyle }} >
                {/* <Checkbox label={p.text} name={p.name} onCheck={this.onCheck} disabled={p.disabled}
                    checked={this.state.value === undefined ? false : (this.state.value == true ? true : false)} labelStyle={{ textAlign: 'left' }}
                    className={showError ? `errorField ${p.className}` : `${p.className}`} /> */}

                <FormControlLabel
                    control={
                        <Checkbox
                            id={p.id}
                            name={p.name}
                            checked={this.state.value === undefined ? false : (this.state.value == true ? true : false)}
                            disabled={p.disabled}
                            onChange={this.onCheck} // Use onChange instead of onCheck
                            className={showError ? `errorField` : `${p.className}`}
                        />
                    }
                    label={p.text} // Text for the label
                    labelPlacement="end" // Align label to the right of the checkbox
                    sx={{ textAlign: 'left', labelStyle: { textAlign: 'left' }, '& .MuiTypography-root': { ...p.labelStyle } }} // Custom label style
                />
                {
                    showError ? (<p className="text-error">{p.error ? p.error : ''}</p>) : null
                }
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        value: state.form[props.name] || props.checked,
        error: state.form && state.form.error && state.form.error[props.name]
    };
};

export default connect(mapStateToProps)(CheckInput);